import React from 'react';
import './index.scss';
import { getDate } from '../../../utils/dateUtils';

function PdfView({ printPdfRef, purchaseOrderDetails }) {
	const {
		is_received,
		is_billed,
		vendor,
		purchase_order_number,
		date,
		organisation,
		delivery_address,
		purchase_order_products,
	} = purchaseOrderDetails || {};
	return (
		<div ref={printPdfRef}>
			<div className="invoice-status">
				<div className="received-s">
					Received Status:{' '}
					<span
						style={{
							color:
								purchaseOrderDetails.status === 'Draft' ? 'black' : is_received ? '#6AA247' : 'red',
						}}
					>
						{purchaseOrderDetails?.is_received === 1
							? 'Received'
							: purchaseOrderDetails?.is_partially_received === 1
								? 'Partially Received'
								: purchaseOrderDetails?.purchase_order_number.includes('PR-') &&
									  purchaseOrderDetails.is_received === 0
									? 'Draft'
									: 'N/A'}
					</span>
				</div>
				<span>|</span>
				<div className="bill-s">
					Bill Status:{' '}
					<span
						style={{
							color:
								purchaseOrderDetails.status === 'Draft' ? 'black' : is_billed ? '#6AA247' : 'red',
						}}
					>
						{purchaseOrderDetails.status === 'Draft'
							? 'N/A'
							: purchaseOrderDetails?.is_billed === 1
								? 'Billed'
								: 'Pending'}
					</span>
				</div>
			</div>
			<div style={{ backgroundColor: 'white', padding: '20px' }}>
				<div
					style={{
						border: '0.1px solid gray',
						padding: '20px',
					}}
				>
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
						}}
					>
						<div>
							<h1 style={{ fontWeight: 'bold' }}>{organisation?.organisation_name}</h1>
							<p style={{ color: '#555B67' }}>
								<div style={{ fontSize: '14px', fontWeight: '500' }}>
									{organisation?.address?.state?.name || 'N/A'}
								</div>
								<div style={{ fontSize: '14px', fontWeight: '500' }}>
									{organisation?.address?.country?.name || 'N/A'}
								</div>
							</p>
						</div>

						<div className="bill-info">
							<h2>Purchase order</h2>
							<p
								style={{
									color: '#555B67',
									fontWeight: 'bold',
									fontSize: '14px',
									marginBottom: '3px',
								}}
							>
								# {purchase_order_number}
							</p>
							<p
								className="label"
								style={{ color: '#555B67', fontWeight: 'bold', fontSize: '14px' }}
							>
								Order Date: <span className="date"> {getDate(date)}</span>
							</p>
						</div>
					</div>

					<div className="delivey-details">
						<div className="address-to">
							<p
								className="label"
								style={{ fontSize: '16px', fontWeight: '600' }}
							>
								Vendor Address
							</p>
							<p className="address">{vendor?.vendor_name}</p>
							<p className="address">
								{`${vendor?.vendor_address?.street_1 || 'N/A'}, 
								${vendor?.vendor_address?.state?.name || 'N/A'}, ${vendor?.vendor_address?.country?.name || 'N/A'}-${vendor?.vendor_address?.zip_code || 'N/A'}`}
							</p>
							<p className="address">{`${vendor?.phone_mobile || 'N/A'} | ${vendor?.email || 'N/A'}`}</p>

							<div style={{ fontSize: '13px', marginTop: '5px' }}>
								DL. No.: {vendor?.drug_license_number || 'N/A'}
							</div>
							<div style={{ fontSize: '13px' }}>
								GSTIN: {vendor?.vendor_other_details?.gst || 'N/A'}
							</div>
						</div>

						<div className="deliver-to">
							<p
								className="label"
								style={{ fontSize: '16px', fontWeight: '600' }}
							>
								Deliver To
							</p>
							<p
								className="address"
								style={{ color: '#555B67' }}
							>
								{delivery_address}
							</p>
						</div>
					</div>

					<table className="items">
						<thead>
							<tr>
								<th>#</th>
								<th>ITEMS AND DESCTIPTION</th>
								<th>PACKAGING</th>
								<th>ORDERED</th>
							</tr>
						</thead>
						<tbody>
							{purchase_order_products?.map((prod, index) => (
								<tr key={prod.purchase_order_product_id}>
									<td>{index + 1}</td>
									<td style={{ color: 'blue' }}>{prod.product.product_name}</td>
									<td>{prod?.product_packaging}</td>
									<td>{prod?.order_quantity}</td>
								</tr>
							))}
						</tbody>
					</table>

					<div
						className="signature"
						style={{ textAlign: 'start', color: '#555B67' }}
					>
						<p>Authorized Signature--------------------</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default PdfView;
